import { Components } from '@mui/material/styles/components';
import theme from '../../provider/controllerBaseTheme';

export const AutocompleteComponent: Components = {
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        padding: 0,
        '& .MuiOutlinedInput-root': {
          padding: 0,
        },
      },
      input: {
        padding: theme.spacing(1.25, 1),
      },
      popupIndicator: {
        width: theme.spacing(3),
        '&:hover': {
          backgroundColor: 'inherit',
        },
      },
      endAdornment: {
        top: 'calc(50% - 1em)',
      },
    },
  },
};
